/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-for-of */
declare const tizen: any;
export interface BrowserDetector {
  isChrome(): boolean;
  isChromecast(): boolean;
  isFirefox(): boolean;
  isSafari(): boolean;
  isEdge(): boolean;
  isInternetExplorer(): boolean;
  isTizen(): boolean;
  isWebos(): boolean;
}

export const getBrowserDetector = (): BrowserDetector => {
  const navigator = window.navigator;
  const uaContains = (...values: string[]) =>
    values.every((value) => navigator.userAgent.includes(value));
  const uaDoesNotContain = (...values: string[]) =>
    values.every((value) => !navigator.userAgent.includes(value));

  // Here is an example Chrome UA string (Note that Chrome also reports itself
  // as Safari):
  // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_3) AppleWebKit/537.36 (KHTML, like Gecko)
  //     Chrome/56.0.2924.87 Safari/537.36
  const CHROME = 'Chrome';

  // See this issue: https://code.google.com/p/google-cast-sdk/issues/detail?id=157
  // Sample Chromecast string:
  // Mozilla/5.0 (CrKey armv7l 0.7.12072) AppleWebKit/537.31 (KHTML, like Gecko) Chrome/26.0.1410.0 Safari/537.31
  const CHROMECAST = 'CrKey';

  // Firefox makes it easy:
  // Mozilla/5.0 (Macintosh; Intel Mac OS X 10.12; rv:51.0) Gecko/20100101 Firefox/51.0
  const FIREFOX = 'Firefox';

  // Safari example UA string:
  // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_3) AppleWebKit/602.4.8 (KHTML, like Gecko)
  //     Version/10.0.3 Safari/602.4.8
  const SAFARI = 'Safari';

  // Edge example UA string (Note that Edge reports itself as Chrome, Safari, and Edge):
  // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
  //     Chrome/51.0.2704.79 Safari/537.36 Edge/14.14393
  const EDGE = 'Edge';

  // IE formats the string a different way than other browsers. Furthermore, IE11 does not supply the
  // 'MSIE' token in the UA string, like previous versions of IE would. So we will check for the presence
  // of 'Trident'. Example IE11 UA string:
  // Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727;
  //     .NET CLR 3.0.30729; .NET CLR 3.5.30729; InfoPath.2; rv:11.0) like Gecko
  const INTERNET_EXPLORER = 'Trident';

  // Tizen example:
  // Mozilla/5.0 (SMART-TV; Linux; Tizen 2.4.0) AppleWebKit/538.1 (KHTML, like Gecko) Version/2.4.0 TV Safari/538.1
  const TIZEN = 'Tizen';

  // LG WebOS example:
  // Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/38.0.2125.122
  // Safari/537.36 WebAppManager
  const WEBOS = 'Web0S'; // Note: that is a zero, not the letter O

  const browserDetector: BrowserDetector = {
    // Edge also reports itself as Chrome, so we need to check against that too.
    // Also check that we are not running on Chromecast.
    isChrome: () =>
      uaContains(CHROME) && uaDoesNotContain(CHROMECAST, EDGE, WEBOS),
    isChromecast: () =>
      uaContains(CHROME, CHROMECAST) && uaDoesNotContain(EDGE),
    isFirefox: () => uaContains(FIREFOX),
    // Chrome, Chromecast, Edge, and Tizen report themselves as Safari as well, so check against those.
    isSafari: () =>
      uaContains(SAFARI) && uaDoesNotContain(CHROME, CHROMECAST, EDGE, TIZEN),
    isEdge: () => uaContains(EDGE),
    isInternetExplorer: () => uaContains(INTERNET_EXPLORER),
    isTizen: () => uaContains(TIZEN),
    isWebos: () => uaContains(WEBOS),
  };

  return browserDetector;
};

export const deepLink = (): any => {
  let requestedAppControl;
  let appControlData;
  if (window.tizen !== 'undefined' && typeof window.tizen != 'undefined') {
    requestedAppControl = window.tizen.application
      .getCurrentApplication()
      .getRequestedAppControl();

    if (
      requestedAppControl &&
      requestedAppControl.appControl &&
      requestedAppControl.appControl.data &&
      requestedAppControl.appControl.data.length
    ) {
      appControlData = requestedAppControl.appControl.data;
      for (const element of appControlData) {
        const payload = getPayload(element);
        if (payload) {
          return payload;
        }
      }
    }
  }
};

const getPayload = (element: any): any => {
  if (element.key === 'PAYLOAD') {
    const actionData = JSON.parse(element.value[0]).values;
    if (actionData && actionData !== null) {
      return JSON.parse(actionData);
    }
  }
  return null;
};

export const removeSplashScreen = () => {
  const splashScreen = document.getElementById('splash-screen');
  if (splashScreen) {
    splashScreen.style.opacity = '0';
    splashScreen.style.transition = 'opacity 0.5s ease-out';
    setTimeout(() => {
      splashScreen.style.display = 'none';
    }, 500); // Wait for fade-out transition
  }
};
